// src/components/operationsAssociate/MyItemsTable.jsx
import React from 'react';
import moment from 'moment';
import { FaCheck, FaPencilAlt, FaUndo } from 'react-icons/fa';

const MyItemsTable = ({ items, onConfirmReceipt, onReportUsage, onReturnItem }) => {

    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending': return 'bg-yellow-100 text-yellow-800';
            case 'Received': return 'bg-blue-100 text-blue-800';
            case 'In Use':
            case 'Partially Consumed': return 'bg-green-100 text-green-800';
            case 'Fully Consumed': return 'bg-gray-100 text-gray-800';
            case 'Returned': return 'bg-purple-100 text-purple-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm">
                    <thead>
                        <tr className="bg-orange-100 text-gray-600 text-left">
                            <th className="px-4 py-2">Item</th>
                            <th className="px-4 py-2">Quantity Issued</th>
                            <th className="px-4 py-2">Quantity Remaining</th>
                            <th className="px-4 py-2">Status</th>
                            <th className="px-4 py-2">Issued On</th>
                            <th className="px-4 py-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center text-gray-500 py-4">
                                    No items have been issued to you.
                                </td>
                            </tr>
                        ) : (
                            items.map(item => (
                                <tr key={item._id} className="border-b hover:bg-gray-50">
                                    <td className="px-4 py-2 font-medium">{item.itemId.name}</td>
                                    <td className="px-4 py-2">{item.quantityIssued} {item.itemId.unitOfMeasure}</td>
                                    <td className="px-4 py-2">
                                        <span className="font-semibold text-gray-700">
                                            {item.quantityIssued - item.quantityConsumed} {item.itemId.unitOfMeasure}
                                        </span>
                                    </td>
                                    <td className="px-4 py-2">
                                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(item.status)}`}>
                                            {item.status}
                                        </span>
                                    </td>
                                    <td className="px-4 py-2">{moment(item.issueDate).format('YYYY-MM-DD')}</td>
                                    <td className="px-4 py-2 text-right">
                                        {item.status === 'Pending' && (
                                            <button onClick={() => onConfirmReceipt(item._id)} className="text-green-600 hover:text-green-800 mr-3" title="Confirm Receipt">
                                                <FaCheck />
                                            </button>
                                        )}
                                        {item.status !== 'Fully Consumed' && item.status !== 'Returned' && (
                                            <>
                                                <button onClick={() => onReportUsage(item)} className="text-blue-600 hover:text-blue-800 mr-3" title="Report Usage">
                                                    <FaPencilAlt />
                                                </button>
                                                <button onClick={() => onReturnItem(item._id)} className="text-purple-600 hover:text-purple-800" title="Return Item">
                                                    <FaUndo />
                                                </button>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyItemsTable;